import api from 'Application/api/api';

const updateTemplateGroup = (id, data, cancelToken = null) =>
    api.post(`project-manager/template-groups/${id}`, data, { cancelToken });

export default updateTemplateGroup;
